module.exports = __webpack_public_path__ + "static/media/image-1.320db80c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/TextEditor/image-1.png
// module id = 270
// module chunks = 0